import { lazy, Fragment } from "react";
import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import Fade from "react-reveal/Fade";

import * as S from "./styles";
import { useMediaQuery } from 'react-responsive'

const SvgIcon = lazy(() => import("../../common/SvgIcon"));
const Container = lazy(() => import("../../common/Container"));

const Footer = ({ t }) => {

  const year = new Date().getFullYear();

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  //const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  //const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })

  const SocialLink = ({ href, src }) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <Fragment>
      <Fade bottom>
        <S.Footer>
          <Container>
            <Row type="flex" justify="space-between">
              <Col lg={5} md={5} sm={6} xs={12}>
                <S.Language>{t("Nous contacter")}</S.Language>
                <S.Large to="/">{t("Posez-nous vos questions")}</S.Large>
                <a href="mailto:contact@anomalyfit.sn">
                  <S.Para>{t(`Email: contact@anomalyfit.sn`)}</S.Para>
                </a>
              </Col>
              <Col lg={5} md={5} sm={6} xs={12}>
                <S.Language>{t("ADRESSE")}</S.Language>
                <S.Para>Anjanahary</S.Para>
                <S.Para>101 Antananarivo</S.Para>
                <S.Para>Madagascar</S.Para>
              </Col>
              <Col lg={5} md={5} sm={6} xs={12}>
                <S.Title>{t("Aniomaly")}</S.Title>
                <S.Large left="true" to="/">
                  {t("A propos")}
                </S.Large>
                <S.Large left="true" to="/">
                  {t("Collections")}
                </S.Large>
              </Col>
              <Col lg={5} md={5} sm={6} xs={12}>
                <S.Title>{t("Partenaires")}</S.Title>
                <S.Large to="/" left="true">
                  {t("Anomaly mg")}
                </S.Large>
                <S.Large left="true" to="/">
                  {t("SYD Agency")}
                </S.Large>
              </Col>
            </Row>
          </Container>
        </S.Footer>
        <S.Extra>
          { isDesktopOrLaptop && 
            <Container border="true">
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                style={{ paddingTop: "0.5rem", height: "5rem"}}
              >
                <S.NavLink to="/">
                  <S.LogoContainer>
                    <SvgIcon
                      src="an.png"
                      aria-label="homepage"
                      width="101px"
                      height="64px"
                    />
                  </S.LogoContainer>
                </S.NavLink>
                <p style={{ marginTop: '20px' }}>Copyright &copy; { year } by <span style={{ color: 'grey' }}>ANIOMALY</span></p>
                <S.FooterContainer>
                  <SocialLink
                    href="https://facebook.com/aniomaly"
                    src="facebook.svg"
                  />
                  <SocialLink
                    href="https://www.linkedin.com/in/andriamisaina-radimison-b259b7167/"
                    src="linkedin.svg"
                  />
                  <SocialLink
                    href="https://instagram.com/aniomaly.mg"
                    src="instagram.svg"
                  />
                </S.FooterContainer>
              </Row>
            </Container>
          }
          { isTabletOrMobile && 
            <Container border="true">
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                style={{ paddingTop: "0.5rem", height: 'auto'}}
              >
                <S.NavLink to="/">
                  <S.LogoContainer style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <SvgIcon
                      src="an.png"
                      aria-label="homepage"
                      width="101px"
                      height="64px"
                    />
                  </S.LogoContainer>
                </S.NavLink>
                <p style={{ marginTop: '20px' }}>Copyright &copy; 2021 by <span style={{ color: 'grey' }}>ANIOMALY</span></p>
                <S.FooterContainer>
                  <SocialLink
                    href="https://facebook.com/anomlybulls/"
                    src="facebook.svg"
                  />
                  <SocialLink
                    href="https://www.linkedin.com/in/andriamisaina-radimison-b259b7167/"
                    src="linkedin.svg"
                  />
                  <SocialLink
                    href="https://instagram.com/anomalybulls/"
                    src="instagram.svg"
                  />
                </S.FooterContainer>
              </Row>
            </Container>
          }
        </S.Extra>
      </Fade>
    </Fragment>
  );
};

export default withTranslation()(Footer);
